import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@mui/material";

const TableauxList = ({
  tableaux,
  removeBranchement,
  TypeBranchement,
  editBranchement
}) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Branchement</TableCell>
            {/*   <TableCell> {TypeBranchement ==='sansAbon' ? 'Tableau'  : 'Puissance' }</TableCell> */}
            <TableCell>
              {" "}
              {TypeBranchement === "sansAbon" ? "Tableau" : "Ampérage"}
            </TableCell>
            <TableCell>Nombre Tableau</TableCell>
            {TypeBranchement === "avecAbon" && <TableCell>Tableau</TableCell>}
            <TableCell sx={{textAlign: 'center'}}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tableaux.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{item.branchement}</TableCell>
              <TableCell>{item.amperage}</TableCell>
              <TableCell>{item.nombre}</TableCell>
              {TypeBranchement === "avecAbon" && (
                <TableCell>{item.tableau}</TableCell>
              )}
              <TableCell sx={{display:'flex',flexDirection: 'row'}}>
                <Button
                  variant="contained"
                  color="error"
                  size="small"
                  onClick={() => removeBranchement(index)}
                  sx={{mr: 4}}
                >
                  Supprimer
                </Button>
            {/*     {action === "modification" && (
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => editBranchement(index)}
                  >
                    Modifier
                  </Button>
                )} */}
                  
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => editBranchement(index)}
                  >
                    Modifier
                  </Button>
               
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableauxList;
